module.exports = __webpack_public_path__ + "static/media/Rating Copy.8bdfab35.svg";